import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "October 2020 - November 2021",
      title: "MA Urban Design and Planning",
      place: "University of Sheffield",
      desc: "Ranked as one of the top 2 universities in building, town, and country planning in the UK by The Guardian 2021, the University of Sheffield provided a comprehensive learning experience in Urban Design and Planning. I was awarded a GBP 7000 Postgraduate Merit Scholarship and graduated with a Master of Arts with Merit (second upper honor / 2:1).",
    },
    {
      yearRange: "September 2014 - August 2016",
      title: "BA Business Administration and Management",
      place: "De Montfort University",
      desc: "Studied abroad at Notre Dame Catholic Sixth Form College in the UK, pursuing GCE A-Levels in Economics, Business Studies, Mathematics, and Chinese language. Among 1800 students, I was part of a diverse international group, gaining a broad perspective on global business practices.",
    },
    {
      yearRange: "September 2014 - August 2016",
      title: "GCE A-Level",
      place: "Notre Dame Catholic Sixth Form College",
      desc: "Completed my GCE A-Levels with a focus on Economics, Business Studies, Mathematics, and Chinese language. As part of a small cohort of international students in a college of 1800, I gained a strong foundation in these subjects, preparing me for further studies in business administration.",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "July 2024 - Present",
      title: "Marketing and Communications Manager",
      place: "Hamorn Chung Canadian Immigration Consultancy Inc.",
      desc: "Developed and managed social media advertising campaigns across platforms such as Facebook, Instagram, and LinkedIn to promote our immigration consultancy services. Contacted clients to understand their needs and provide tailored immigration consultancy solutions. Built and maintained strong client relationships, ensuring high levels of satisfaction and repeat business.",
    },
    {
      yearRange: "February 2024 - May 2024",
      title: "Social Media Manager",
      place: "Homesy Rent-To-Own",
      desc: "Efficiently managed phone inquiries, reached out to potential leads, and scheduled appointments, achieving a 98% satisfaction rate. Developed and executed social media strategies across Instagram, TikTok, and Facebook, resulting in a 7% increase in the company's social media following within a month. Monitored social media trends and analytics, utilizing insights to adjust content strategies and enhance reach and engagement.",
    },
    {
      yearRange: "October 2023 - February 2024",
      title: "Bank Advisor",
      place: "Royal Bank of Canada",
      desc: "Enhanced client engagement, achieving a 20% increase in referrals and sales. Boosted client experience and retention by 15% through effective education and technology use. Resolved banking issues, improving client satisfaction by 25%. Fostered partnerships, driving 30% growth in collaborative business.",
    },
    {
      yearRange: "August 2023 - Present",
      title: "Social Media Marketing Assistant",
      place: "CWF Group Inc. & CWF Group Mortgages Inc.",
      desc: "Responsible for creating compelling written content and designing visuals for various social media platforms. Monitored campaign metrics and compiled performance reports to assess effectiveness.",
    },
    {
      yearRange: "July 2023 - August 2023",
      title: "Marketing Assistant",
      place: "UNICEF CANADA",
      desc: "Enhanced donor engagement by 60%, contributing to a 50% increase in fundraising, through strategic communication and effective implementation of long-term fundraising plans.",
    },
    {
      yearRange: "November 2022 - May 2023",
      title: "Marketing and Business Development Assistant Officer",
      place: "BUDA Surveying Limited",
      desc: "Led website redesign resulting in a 30% increase in user engagement, managed social media platforms achieving a 20% growth in followers, assisted in creating 15+ detailed business proposal maps using AutoCAD and SketchUp, and streamlined office operations, enhancing administrative efficiency by 25%.",
    },
    {
      yearRange: "September 2022 - October 2022",
      title: "Entry Level Marketing Agent",
      place: "Trillium Health Partners",
      desc: "Successfully invited 150+ new monthly donors through door-to-door campaigns, built strong rapport leading to a 35% donor retention rate, and demonstrated leadership by earning a promotion within two weeks.",
    },
    {
      yearRange: "August 2021 - August 2022",
      title: "Operation Clerk + HR (Crew) Clerk",
      place: "AMCL",
      desc: "Managed ommunications in crew management and HR, effectively coordinating with charters, agents, and masters, leading to a 40% improvement in operational efficiency.",
    },
    {
      yearRange: "January 2020 - August 2020",
      title: "Personal Assistant & General Administrator",
      place: "Team Wang",
      desc: "Enhanced office management and HR processes, resulting in a 20% reduction in administrative workload, and successfully completed 10+ research and project assignments.",
    },
    {
      yearRange: "October 2019 - November 2019",
      title: "Recruitment Consultant",
      place: "ONE ARROW CONSULTING GROUP",
      desc: "Streamlined candidate assessment and interviewing processes, increasing candidate placement rate by 25%, and developed 30+ detailed job descriptions.",
    },
    {
      yearRange: "February 2019 - May 2019",
      title: "Part Time CRM Clerk",
      place: "BVLGARI",
      desc: "Organized an annual dinner and multiple events, leading to a 15% increase in VIP customer engagement, and analyzed fashion trends data that influenced two major marketing campaigns.",
    },
    {
      yearRange: "April 2018 - September 2018",
      title: "Part-Time Marketing",
      place: "Hong Kong Economic Times Limited",
      desc: "Assisted in social media management and basic market research, contributing to a 10% increase in online engagement.",
    },
    {
      yearRange: "March 2017 - December 2017",
      title: "Sale Marketing Assistant",
      place: "PAMYCARIE Hong Kong",
      desc: "Managed social media and online promotions, resulting in a 20% rise in online sales, and conducted market research that identified key customer trends leading to a 25% improvement in targeted marketing strategies.",
    },
  ];

  const skills = [
    {
      name: "AutoCAD",
      percent: 90,
    },
    {
      name: "Adobe Illustrator (Ai)",
      percent: 90,
    },
    {
      name: "Adobe Photoshop (Ps)",
      percent: 90,
    },
    {
      name: "Adobe InDesign (Id)",
      percent: 90,
    },
    {
      name: "SketchUp",
      percent: 85,
    },
    {
      name: "Microsoft Office",
      percent: 85,
    },
    {
      name: "Figma",
      percent: 75,
    },
    {
      name: "QuickBooks",
      percent: 60,
    },
    // Including language proficiencies in the skills array
    {
      name: "Cantonese (Language)",
      percent: 100, // Assuming Native or Bilingual Proficiency as 100%
    },
    {
      name: "English (Language)",
      percent: 100, // Assuming Full Professional Proficiency as 100%
    },
    {
      name: "Mandarin (Language)",
      percent: 100, // Assuming Full Professional Proficiency as 100%
    },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
